import { render, staticRenderFns } from "./LabelImage.vue?vue&type=template&id=2fc6ac8e&"
import script from "./LabelImage.vue?vue&type=script&lang=js&"
export * from "./LabelImage.vue?vue&type=script&lang=js&"
import style0 from "./LabelImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports